// extracted by mini-css-extract-plugin
export default {"icon_item_container":"icon-item_icon_item_container__EE6ff"};